import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { upsertCartItem } from "../../../server/CollectSite";
import { setUserEntry } from "../../../server/Customer";
import { ShoppingCart } from "lucide-react";

const ProductAddToCart = ({
  element,
  haveInfo,
  cardOverlay = false,
  retailCard = false,
}) => {
  const dispatch = useDispatch();
  const { user, role, productsInCart, stationId } = useSelector((state) => ({
    role: state.user.role,
    user: state.user.user,
    productsInCart: state.productsInCart.productsInCart,
    stationId: state.user.stationId,
  }));

  const productId = element.productId;
  const inCart = productsInCart.find((item) => item.productId === productId);
  const [inputValue, setInputValue] = useState(inCart?.quantity || 0);

  useEffect(() => {
    setInputValue(inCart?.quantity || 0);
  }, [inCart?.quantity]);

  const callUpsertCartItem = (productObj, quantity, stationId) => {
    if (!user || localStorage.getItem("userRole").includes("guest")) {
      dispatch(setUserEntry([true, "login"]));
    } else {
      const finalPrice = parseFloat(productObj.pricing.price).toFixed(2);
      const promoId =
        productObj.pricing.promotions?.length > 0
          ? productObj.pricing.promotions[0].promoId
          : undefined;
      dispatch(
        upsertCartItem(
          productId,
          finalPrice,
          quantity,
          String(stationId),
          promoId,
          productObj, // ← pass product for optimistic display
        ),
      );
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      setInputValue(value === "" ? "" : parseInt(value));
    }
  };

  const handleInputBlur = () => {
    const raw = parseInt(inputValue, 10) || 0;
    const newQuantity =
      raw <= 0
        ? 0
        : Math.max(weightJump, Math.round(raw / weightJump) * weightJump);

    if (newQuantity !== (inCart?.quantity || 0)) {
      callUpsertCartItem(inCart?.product || element, newQuantity, stationId);
    }
    setInputValue(inCart?.quantity || 0);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.target.blur();
    }
  };

  const weightJump =
    parseInt(
      element?.weightJump ||
        element?.product?.weightJump ||
        inCart?.product?.weightJump,
    ) > 0
      ? parseInt(
          element?.weightJump ||
            element?.product?.weightJump ||
            inCart?.product?.weightJump,
        )
      : 1;

  return (
    <div
      className={`${inCart ? "add-to-cart in-cart" : "add-to-cart not-in-cart"}${
        cardOverlay ? " add-to-cart--card-overlay" : ""
      }${retailCard ? " add-to-cart--retail-card" : ""}`}
    >
      {!role &&
      (element.availability?.["availableQuantity"] >= weightJump ||
        (inCart && inCart.quantity > 0)) ? (
        <div
          className="wrap"
          onClick={
            !inCart
              ? () => callUpsertCartItem(element, weightJump, stationId)
              : null
          }
        >
          {inCart && inCart.quantity > 0 ? (
            <>
              <div
                className="add-btn"
                onClick={
                  inCart &&
                  (!haveInfo ||
                    inCart.availability?.["availableQuantity"] >= weightJump)
                    ? () => {
                        const newQty =
                          (Math.floor(inCart.quantity / weightJump) + 1) *
                          weightJump;
                        callUpsertCartItem(inCart.product, newQty, stationId);
                      }
                    : null
                }
              >
                <p>+</p>
              </div>
              <div className="col-lg-7">
                <input
                  type="text"
                  value={inputValue}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                  onKeyDown={handleInputKeyDown}
                  inputMode="numeric"
                />
              </div>
              <div
                className="minus-btn"
                onClick={
                  inCart
                    ? () => {
                        const newQty =
                          Math.floor((inCart.quantity - 1) / weightJump) *
                          weightJump;
                        callUpsertCartItem(
                          inCart.product,
                          Math.max(0, newQty),
                          stationId,
                        );
                      }
                    : null
                }
              >
                <p>-</p>
              </div>
            </>
          ) : (
            <p
              className={retailCard ? "add-to-cart__cta-retail" : undefined}
              onClick={
                !inCart && (!haveInfo || element.QuantityCanOrder >= weightJump)
                  ? () => {
                      console.log("weightJump", weightJump);
                      callUpsertCartItem(element, weightJump, stationId);
                    }
                  : null
              }
            >
              <ShoppingCart
                size={retailCard ? 18 : cardOverlay ? 22 : 24}
                aria-hidden
              />
              {retailCard ? (
                <span className="add-to-cart__cta-label">הוסף לסל</span>
              ) : null}
            </p>
          )}
        </div>
      ) : (
        inCart &&
        inCart?.quantity === 0 && <div className="outOfStock">אזל מהמלאי</div>
      )}
    </div>
  );
};

export default ProductAddToCart;
